var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-lupa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lupa",
    clipPath: "url(#clip-lupa)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-9.821 -12.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    transform: "translate(6.18 6.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_752",
    "data-name": "Trazado 752",
    d: "M78.849,41.674A37.174,37.174,0,1,1,41.674,4.5,37.174,37.174,0,0,1,78.849,41.674Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_753",
    "data-name": "Trazado 753",
    d: "M48.559,47.949,24.975,24.975",
    transform: "translate(39.08 39.59)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.5d6103c4937b2c5fcb3fd4ed574c78df.svg";
export { ForwardRef as ReactComponent };